import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white/60">
        <span className="font-mono text-xs tracking-[0.3em] uppercase">Authenticating…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
